<template>
    <v-container class="password-forgot justify-center">
        <h1 class="text-center">Bạn bị quên mật khẩu?</h1>
        <bot-spinner v-model="spinner">
            <template>
                <div v-if="action === 'reseting'">
                    <v-form
                        v-model="isValidReset"
                        ref="formReset"
                        @submit.prevent="handleResetPassword"
                    >
                        <table class="bot-table">
                            <tbody>
                                <tr>
                                    <th>Họ tên:</th>
                                    <td>{{ vReset.MemberName }}</td>
                                </tr>
                                <tr>
                                    <th>Email:</th>
                                    <td>{{ vReset.Email }}</td>
                                </tr>
                                <tr>
                                    <th>Giới tính:</th>
                                    <td>
                                        {{ vReset.Gender === 2 ? "nữ" : "nam" }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <fieldset>
                            <legend>Nhập mã reset và tạo lại mật khẩu</legend>
                            <v-list-item>
                                <v-text-field
                                    autofocus
                                    v-model="vReset.ResetCode"
                                    label="Mã reset"
                                    :rules="[
                                        (val) =>
                                            vld.text({
                                                field: 'reset code',
                                                value: val,
                                            }),
                                    ]"
                                ></v-text-field>
                            </v-list-item>
                            <v-list-item>
                                <v-text-field
                                    v-model="vReset.Password"
                                    label="Mật khẩu"
                                    type="password"
                                    :rules="[
                                        (val) =>
                                            vld.text({
                                                field: 'mật khẩu',
                                                value: val,
                                            }),
                                    ]"
                                ></v-text-field>
                            </v-list-item>
                            <v-list-item>
                                <v-text-field
                                    v-model="vReset.ConfirmPassword"
                                    label="Nhập lại mật khẩu"
                                    type="password"
                                    :rules="[
                                        (val) =>
                                            vld.text({
                                                field: 'lại mật khẩu',
                                                value: val,
                                            }),
                                        (val) =>
                                            (!!val &&
                                                val === vReset.Password) ||
                                            'Mật khẩu và nhập lại mật khẩu chưa giống nhau!',
                                    ]"
                                ></v-text-field>
                            </v-list-item>
                        </fieldset>
                    </v-form>
                    <div class="text-center">
                        <v-btn
                            class="ma-2"
                            color="primary"
                            @click="handleResetPassword"
                        >
                            Kiểm tra
                            <v-icon right> mdi-check </v-icon>
                        </v-btn>
                    </div>
                </div>
                <div v-else-if="action === 'done'">
                    <v-alert type="warning"
                        >Hệ thống sẽ chuyển hướng sau
                        {{ this.timeoutRedirect }}s nữa</v-alert
                    >
                </div>
                <div v-else>
                    <v-form
                        v-model="isValidForgot"
                        ref="formForgot"
                        @submit.prevent="sendResetCode"
                    >
                        <v-list-item>
                            <v-text-field
                                autofocus
                                label="hãy nhập email đăng ký"
                                v-model="vForgot.Email"
                                :rules="[vld.email]"
                            ></v-text-field>
                        </v-list-item>
                    </v-form>
                    <div class="text-center">
                        <v-btn
                            class="ma-2"
                            color="primary"
                            @click="sendResetCode"
                        >
                            Kiểm tra
                            <v-icon right> mdi-check </v-icon>
                        </v-btn>
                    </div>
                </div>
                <v-alert v-if="snackbar.visible" :type="snackbar.color">
                    {{ isError(snackbar.text) }}
                </v-alert>
            </template>
        </bot-spinner>
    </v-container>
</template>

<script>
import BotSpinner from "@/components/bot/spinner/bot.spinner.vue";
const cafe = {
    default: {
        sp: {
            snb: "views/snackbar/show",
            authen: {
                password: {
                    forgot: "authen/password/forgot",
                    reset: "authen/password/reset",
                    loadPasswordReset: "authen/password/loadPasswordReset",
                },
            },
        },
        storePathSnackbar: "views/snackbar/show",
    },
    sms: {
        start: "Hãy chắc là bạn đăng nhập được vào email bạn đã đăng ký!",
        success: {
            sendMail:
                "Chúng tôi đã gởi mã reset đến email của bạn, bạn hãy vui lòng kiểm tra email!",
            reset: "Chúc mừng bạn đã đặt lại mật khẩu thành công, hệ thống sẽ chuyển hướng trong ít giây nữa!",
        },
    },
};
const df = cafe.default;

export default {
    name: "PasswordForgot",

    components: {
        "bot-spinner": BotSpinner,
    },

    // this is state
    data() {
        return {
            timeoutRedirect: 6,
            isValidForgot: false,
            isValidReset: false,
            hlog: this.$options.filters.hlog,
            isError: this.$options.filters.is.error,
            action: null,
            vForgot: {
                Email: null,
            },
            vReset: {
                Email: null,
                MemberName: null,
                Gender: null,
                ResetCode: null,
                Password: null,
                ConfirmPassword: null,
            },
            vld: this.$options.filters.validate,
            spinner: {
                visible: false,
                color: "red",
            },
            snackbar: {
                visible: true,
                color: "info",
                text: null,
            },
        };
    },

    async asyncData({ store }) {
        const dp = store.dispatch;
        await dp(df.sp.authen.password.loadPasswordReset);
    },

    mounted() {
        this.reloadData();
    },

    methods: {
        async sendResetCode() {
            /*********|form validate|*********/
            const { formForgot } = this.$refs;
            if (!formForgot) return;
            this.isValidForgot = formForgot.validate();
            if (!this.isValidForgot) return;

            /*********|config filter|*********/
            this.spinner.visible = true;
            const dp = this.$store.dispatch;
            let { Email } = this.vForgot;
            let payload = { Email };
            this.hlog.start("password.reset.send.code", "start", payload);
            let text, snb;
            const res_code = await dp(df.sp.authen.password.forgot, payload);
            this.spinner.visible = false;
            text = res_code.error;
            snb = { visible: true, text, color: "error" };
            if (text) return (this.snackbar = snb);
            this.reloadData();
        },
        async handleResetPassword() {
            const { formReset } = this.$refs;
            if (!formReset) return;
            this.isValidReset = formReset.validate();
            if (!this.isValidReset) return;

            /*********|config filter|*********/
            this.hlog.start("password.reset.send.code", "start", this.vReset);
            this.spinner.visible = true;
            const dp = this.$store.dispatch;
            let text, snb;
            let { Email, MemberName, Gender, ResetCode, Password } =
                this.vReset;
            let payload = { Email, MemberName, Gender, ResetCode, Password };
            let res_reset = await dp(df.sp.authen.password.reset, payload);
            this.spinner.visible = false;
            text = res_reset.error;
            snb = { visible: true, text, color: "error" };
            if (text) return (this.snackbar = snb);
            this.spinner.visible = true;
            text = cafe.sms.success.reset;
            snb = { visible: true, text, color: "success" };
            this.snackbar = snb;
            this.handleRedirect();
        },
        handleRedirect() {
            let ins = setInterval(() => {
                this.timeoutRedirect -= 1;
                if (this.timeoutRedirect > 0) return;
                clearInterval(ins);
                window.location.href = "/authen/login";
            }, 1000);
        },
        reloadData() {
            let pw = this.$store.state.authen.password;
            this.action = pw.status;
            const { Email, MemberName, Gender } = pw;
            this.vReset = { Email, MemberName, Gender };
            let snb = { visible: true, text: null, color: "info" };
            switch (this.action) {
                case "reseting":
                    snb.text = cafe.sms.success.sendMail;
                    snb.color = "warning";
                    break;
                case "done":
                    snb.text = cafe.sms.success.reset;
                    snb.color = "success";
                    break;
                default:
                    snb.text = cafe.sms.start;
                    break;
            }
            this.snackbar = snb;
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.password-forgot {
    position: relative;
    max-width: 600px;
}

.password-forgot table.bot-table {
    width: 100%;
    font-size: 16px;
    border: 1px solid gray;
    border-spacing: 2px;
    border-color: grey;
    border-collapse: collapse;
}

.password-forgot table.bot-table tr th, .password-forgot table.bot-table tr td {
    padding: 16px;
}

.password-forgot table.bot-table tr th {
    text-align: right;
    width: 40%;
}

.password-forgot table.bot-table tr:not(:last-child) td {
    text-align: left;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

fieldset {
    border-width: 1px;
    padding: 20px;
}

fieldset:not(:first-child) {
    margin-top: 25px;
}

fieldset legend {
    padding: 0 12px;
    font-family: 'Roboto-Bold';
}
</style>



// WEBPACK FOOTER //
// password.forgot.vue